export class TikTokModule {
  public static trackEvent(
    event: TikTokPixelStandardEvent | string,
    params?: TikTokPixelEventProperties,
    options?: TikTokPixelTrackOptions,
  ) {
    if (!TT_PIXEL_LIST || !window.ttq) {
      console.error('TikTok pixel is not initialized', TT_PIXEL_LIST);
      return;
    }

    console.log('TikTok log event: ', event, params, options);
    window.ttq.track(event, params, options);
  }

  public static identify(params: TikTokPixelIdentifyProperties) {
    if (!TT_PIXEL_LIST || !window.ttq) {
      console.error('TikTok pixel is not initialized', TT_PIXEL_LIST);
      return;
    }

    console.log('TikTok identify: ', params);
    window.ttq.identify(params);
  }
}
